module.exports = __webpack_public_path__ + "static/media/social-work.75f91544.jpg";